module.exports = __webpack_public_path__ + "img/image_webinars03@2x.557c3dab.png";